const o = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"><path stroke="currentColor" stroke-linejoin="round" d="M12.707 22.88a1 1 0 0 1-1.414 0L1.119 12.708a1 1 0 0 1 0-1.414L11.293 1.119a1 1 0 0 1 1.414 0l10.174 10.174a1 1 0 0 1 0 1.414L12.707 22.881Z"></path></svg>';
export {
  o as default
};
